export default function pluralize( count, singular, plural ) {
	if( 1 === count ) {
		return singular.replace( '%s', count );
	} else {
		return plural.replace( '%s', count );
	}
}
